import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import PageBlog from "../components/PageBlog";
import ImageStack from "../components/ImageStack";

const BlogPost = (props) => {
  const location = useLocation();
  const [post, setPost] = useState(null);
  const [innerContent, setInnerContent] = useState("");

  useEffect(() => {
    setPost(location.state);
    fetch(`../content/art/art-post_${location.state.id}/body.html`)
      .then((response) => {
        return response.text();
      })
      .then((html) => {
        setInnerContent(html);
      });
    console.log(innerContent);
  }, []);

  if (!post) {
    return <div>Loading...</div>;
  }

  document.title = "Art - De School Amsterdam";
  const headerTitle = post.title;
  const mainImage = post.mainImage.map((image) => {
    return <ImageStack image={image} art={true} />;
  });
  const extraTitleOne = "Back to Art";
  const extraTitleOneLink = "/art";

  const content = (
    <div
      className="content"
      dangerouslySetInnerHTML={{ __html: innerContent ? innerContent : "" }}
    ></div>
  );

  return (
    <PageBlog
      headerTitle={headerTitle}
      description={post.intro}
      extraTitleOne={extraTitleOne}
      extraTitleOneLink={extraTitleOneLink}
      content={content}
      mainImage={mainImage}
      langNL={props.langNL}
      changeLang={props.changeLang}
    />
  );
};

export default BlogPost;
